import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from 'theme';

import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.redDark};
    background: ${COLORS.coralLight};
    border-color: ${COLORS.red};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.redDark};
    }
  }
`;

const DeclinedTag = (props) => <StyledTag label="Declined" {...props} />;

export default memo(DeclinedTag);
